<script setup>
import { useRoute, useRouter } from 'vue-router'
import { useMeta, useQuasar } from 'quasar'
import { useStore } from 'vuex'
import ScrollTop from 'src/components/shared/ScrollTop.vue'
import { LocalStorageService } from 'src/services/index.js'
import Intercom, { update as IntercomUpdate } from '@intercom/messenger-js-sdk'
import { watch } from 'vue'

const $q = useQuasar()
const store = useStore()
const router = useRouter()
const route = useRoute()

Intercom({ app_id: process.env.VUE_APP_INTERCOM_APP_ID })
watch(
  () => router.currentRoute.value,
  () => IntercomUpdate({ last_request_at: parseInt(new Date().getTime() / 1000) })
)

useMeta(() => {
  const meta = {
    title: process.env.VUE_APP_DOMAIN_TITLE,
  }

  const { title } = route.meta
  if (title !== undefined) {
    meta.title += ` | ${title}`
  }

  return meta
})

const useStorageSettings = () => {
  if (LocalStorageService.has('settings')) {
    store.dispatch('updateSettings', {
      ...LocalStorageService.get('settings'),
      shouldRouterPush: false,
    })
  }
}
useStorageSettings()

const setSizes = () => {
  $q.screen.setSizes({ lg: 1440, md: 768 })
}
setSizes()

const setTheme = () => {
  const theme = localStorage.theme ?? 'darkTheme'
  store.commit('SET_THEME', theme)
}
setTheme()
</script>

<template>
  <RouterView />
  <ScrollTop />
</template>
